@if (list) {
  <section class="tw-mt-16 tw-text-sm tw-leading-snug">
    @if (
      !listByCategory[userType].pstx.article.isBroken ||
      !listByCategory[userType].ieo.article.isBroken
    ) {
      <p class="p-text-p tw-mb-2.5">
        {{ 'learn.sidebar.readMore' | translate }}
      </p>
    }
    <ul class="list--read-more tw-pl-5">
      @for (item of list[userType]; track item) {
        @if (item.category !== category && !item.article.isBroken) {
          <li>
            <a
              class="tw-inline-block tw-py-1 tw-underline hover:tw-underline"
              [routerLink]="item.article?.url"
            >
              {{ 'learn.sidebar.' + item.category | translate }}
            </a>
          </li>
        }
      }
    </ul>
    <p class="p-text-p">
      {{ 'learn.sidebar.not' + userType | translate }}?
      @if (userType == 'issuer') {
        <a [routerLink]="listByCategory.investor[category].article?.url">
          {{ 'learn.sidebar.goToInvestor' | translate }}
        </a>
      }
      @if (userType == 'investor') {
        <a [routerLink]="listByCategory.issuer[category].article?.url">
          {{ 'learn.sidebar.goToIssuer' | translate }}
        </a>
      }
    </p>
  </section>
}
